module.exports = __webpack_public_path__ + "img/744.a71f82f5.jpg";